import React, { useEffect, useState } from "react"
import { Checkbox, message as messager, Modal } from "antd"
import { accountAuditReject, GetAuditReject, GetAuditRejectReasons } from "../../../../../../services/dct/DctService"

import clsName from './index.module.scss'

interface RejectModalProps {
  takeSubjectCodes: ()=> string[]
  onClose: (reload: boolean)=> void
}
const RejectModal: React.FC<RejectModalProps> = ({ takeSubjectCodes, onClose })=> {

  const [rejectOptions, setRejectOptions] = useState<{text: string}[]>([])

  // 拒绝
  const [reasons, setReasons] = useState<string[]>([])
  const [remark, setRemark] = useState('')

  const handleConfirm = async ()=> {

    if (reasons.length === 0) {
      messager.error('请选择拒绝理由')
      return
    }

    const pieces = reasons.filter(t=> t !== '其他')

    let attach = remark
    // 因为“其他”移除了
    if (pieces.length === reasons.length) {
      attach = ''
    } else {
      if (remark.length === 0) {
        messager.error('请输入其他拒绝理由')
        return
      }
    }

    const { code, message } = await GetAuditReject({
      reasons: pieces.join(';'),
      remark: attach,
      subjectCodes: takeSubjectCodes(),
    })

    if (code === 0) {
      messager.success(message)
      onClose(true)
    }
  }

  const handleChange = (checked: string[])=> {
    setReasons(checked)
    if (!checked.includes('其他')) {
      setRemark('')
    }
  }

  const fetchData = async()=> {
    const { data } = await GetAuditRejectReasons()

    setRejectOptions(data)
  }

  useEffect(()=> {
    fetchData()
  }, [])

  return (
    <Modal
      open
      title="请选择拒绝理由"
      onOk={handleConfirm}
      onCancel={()=> onClose(false)}
      okText="确定"
      cancelText="取消"
      className={clsName.modal}
    >
      <Checkbox.Group onChange={(checked)=> handleChange(checked as string[])}>
        {
          rejectOptions.map(({ text }, index)=> <Checkbox value={text} key={index} className={clsName.checkbox}>{text}</Checkbox>)
        }
      </Checkbox.Group>
      {
        reasons.includes('其他') && (
          <textarea
            placeholder="请输入拒绝理由"
            onChange={({target})=> setRemark(target.value)}
            value={remark}
            className={clsName.typing}
          />
        )
      }
  </Modal>
  )
}

export default RejectModal
